module.exports = __webpack_public_path__ + "static/media/07.ec7ae091.jpg";